import React from 'react';
import { RhColumns } from '../../../../../../../dum';
import { GroupsInput } from './groups/groups-input';
import { KiloPriceInput } from './kilo-price/kilo-price-input';
import { KilosInput } from './kilos/kilos-input';
import { OrderQuotationProductInput } from './product/product-input';
import { ProposedDescriptionInput } from './proposed-description/proposed-description-input';
import { GroupWeightInput } from './group-weight/group-weight-input';
import { IOrderQuotation } from '../../order-quotation-form';
import { useCalculateProductsTotal } from '../../helpers/use-calculate-products-total';
import { GroupPriceInput } from './group-price/group-price-input';

export const ORDER_QUOTATION_PRODUCTS: keyof IOrderQuotation =
    'order_quotation_products';

export const GROUP_WEIGHT: keyof IOrderQuotation['order_quotation_products'][number] =
    'group_weight';
export const KILO_PRICE: keyof IOrderQuotation['order_quotation_products'][number] =
    'kilo_price';
export const GROUP_PRICE: keyof IOrderQuotation['order_quotation_products'][number] =
    'group_price';
export const GROUPS: keyof IOrderQuotation['order_quotation_products'][number] =
    'groups';
export const KILOS: keyof IOrderQuotation['order_quotation_products'][number] =
    'kilos';
export const PRODUCT: keyof IOrderQuotation['order_quotation_products'][number] =
    'product';
export const PROPOSED_DESCRIPTION: keyof IOrderQuotation['order_quotation_products'][number] =
    'proposed_description';

export const DEFAULT_ORDER_QUOTATION_PRODUCT: IOrderQuotation['order_quotation_products'][number] =
    {
        product: null,
        proposed_description: '',
        kilos: 0,
        groups: 0,
        group_weight: 0,
        kilo_price: 0,
        group_price: 0,
    };

export function OrderQuotationProductsColumns() {
    const { calculateProductsTotal } = useCalculateProductsTotal();

    return (
        <RhColumns
            title={'Productos'}
            name={ORDER_QUOTATION_PRODUCTS}
            defaultValue={DEFAULT_ORDER_QUOTATION_PRODUCT}
            onDelete={() => {
                calculateProductsTotal();
            }}
            items={[
                {
                    cellGrow: 3,
                    getField: (index) => {
                        return <OrderQuotationProductInput index={index} />;
                    },
                },
                {
                    cellGrow: 3,
                    getField: (index) => {
                        return <ProposedDescriptionInput index={index} />;
                    },
                },
                {
                    getField: (index) => {
                        return <GroupsInput index={index} />;
                    },
                },
                {
                    getField: (index) => {
                        return <GroupPriceInput index={index} />;
                    },
                },
                {
                    getField: (index) => {
                        return <GroupWeightInput index={index} />;
                    },
                },
                {
                    getField: (index) => {
                        return <KilosInput index={index} />;
                    },
                },
                {
                    getField: (index) => {
                        return <KiloPriceInput index={index} />;
                    },
                },
            ]}
        />
    );
}
